// extracted by mini-css-extract-plugin
export var alternate = "_t-j";
export var black = "_t-6";
export var blue = "_t-f";
export var blueLight = "_t-e";
export var brand = "_t-8";
export var darkMode = "_t-b";
export var error = "_t-a";
export var gray = "_t-5";
export var grayBlue = "_t-d";
export var iconWrapper = "_t-3";
export var inactive = "_t-7";
export var indigo = "_t-g";
export var orange = "_t-i";
export var pink = "_t-h";
export var primary = "_t-0";
export var purple = "_t-9";
export var success = "_t-4";
export var warning = "_t-c";
export var white = "_t-1";
export var whiteSuccess = "_t-2";